import { useTheme } from '../hooks/useTheme';

function ThemeProvider({ children }) {
  useTheme();
  return children;
}

export default ThemeProvider;